import styled from 'styled-components';
import {
  display,
  DisplayProps,
  gridGap,
  GridProps,
  justifyContent,
  JustifyContentProps,
} from 'styled-system';

export const Title = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`;

export const ContentWrapper = styled.div<GridProps & JustifyContentProps>`
  text-align: left;
  display: flex;
  height: 100%;
  align-items: center;
  ${gridGap};
  ${justifyContent};
`;

export const Price = styled.div<GridProps & DisplayProps>`
  align-items: center;
  ${gridGap};
  ${display};
`;
